var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-page',{staticClass:"page"},[_c('com-head'),_c('app-page-inner',{staticClass:"page-inner"},[_c('app-page-title',{attrs:{"text":_vm.page.title}}),_c('app-page-text',{attrs:{"html":_vm.page.content}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }